import { UnitGroupFieldProps } from 'react-islands';

/** Props for the unit group island; `unitGroup` must carry the `serverError` extender. */
export function makeUnitGroupFieldProps(
  unitGroup: KnockoutObservable<number | null>,
  { disabled }: { disabled: boolean }
): UnitGroupFieldProps {
  return {
    unitGroupId: unitGroup,
    onChange: (unitGroupId: number | null) => {
      unitGroup(unitGroupId);
      unitGroup.serverError(null);
    },
    error: unitGroup.serverError,
    disabled,
  };
}
